import React, { Fragment, useState } from 'react';
import DatePicker from 'react-datepicker';
import SvgIcon from '../../../common/SvgIcon';
import { TASK_AVAILABILITY_TYPE, TASK_DAY_OFF_TYPE } from './Constants';
import TimePicker from "./TimePicker";

const TaskPopup = ({ task, onUpdate, onDelete, onCloseModal, admin }) => {
  const [start, setStart] = useState(task.start);
  const [end, setEnd] = useState(task.end);
  const [taskKind, setTaskKind] = useState(task.kind);

  const taskDate = start.toLocaleDateString("en-US", { month: 'long' ,day: '2-digit' , weekday: 'short' });
  const handleUpdate = () => {
    start.setDate(task.start.getDate());
    start.setMonth(task.start.getMonth());
    start.setFullYear(task.start.getFullYear());
    end.setDate(task.start.getDate());
    end.setMonth(task.start.getMonth());
    end.setFullYear(task.start.getFullYear());
    const params = { start, end };
    if (end < start) {
      params.start = end;
      params.end = start;
    }
    onUpdate({ ...task, ...params, kind: taskKind });
  };

  const dayOff = taskKind === TASK_DAY_OFF_TYPE;
  const toggleTaskDayOff = () => {
    const toggle = dayOff ? TASK_AVAILABILITY_TYPE : TASK_DAY_OFF_TYPE;
    setTaskKind(toggle);
  };

  return (
    <Fragment>
      <div className="popupBackShadow" onClick={onCloseModal}>

      </div>

      <div className="taskPopup">
        <div className="moodboard-modal_close" onClick={onCloseModal}/>
        <h3> Availability <br/> {taskDate} </h3>
        <div className="taskType">
          <label className="form-group checkbox">
            <input
              type="checkbox"
              name="kind"
              className="checkbox_input"
              checked={dayOff}
              disabled={admin}
              onChange={() => !admin && toggleTaskDayOff()}
            />
            <SvgIcon icon="icon-check" className="checkbox_icon"/>
            <span className="control-label">Day off</span>
          </label>
        </div>
        {!dayOff && (
          <div className="taskTime">
            <TimePicker
              selectedTime={start}
              onChange={(time) => setStart(time)}
              readOnly={dayOff || admin}
            />
            <span>to</span>
            <TimePicker
              selectedTime={end}
              onChange={(time) => setEnd(time)}
              readOnly={dayOff || admin}
            />

            {/*<DatePicker*/}
            {/*  selected={start}*/}
            {/*  readOnly={dayOff}*/}
            {/*  onChange={date => setStart(date)}*/}
            {/*  showTimeSelect*/}
            {/*  showTimeSelectOnly*/}
            {/*  timeIntervals={30}*/}
            {/*  timeCaption="Start"*/}
            {/*  dateFormat="h:mm aa   "*/}
            {/*  minTime={new Date(task.start).setHours(7, 0, 0)}*/}
            {/*  maxTime={new Date(task.start).setHours(21, 30, 0)}*/}
            {/*/>*/}
            {/*<span>to</span>*/}
            {/*<DatePicker*/}
            {/*  selected={end}*/}
            {/*  readOnly={dayOff}*/}
            {/*  onChange={date => setEnd(date)}*/}
            {/*  showTimeSelect*/}
            {/*  showTimeSelectOnly*/}
            {/*  timeIntervals={30}*/}
            {/*  timeCaption="End"*/}
            {/*  dateFormat="h:mm aa"*/}
            {/*/>*/}
          </div>
        )}
        <div className='popupActions'>
          {!admin && (
            <Fragment>
              <button onClick={() => onDelete(task)} className="btn -empty -y2023">Delete</button>
              <button onClick={handleUpdate} className="btn -primary -y2023">Save</button>
            </Fragment>
          )}
        </div>
      </div>
    </Fragment>
  );
};

export default TaskPopup;



// WEBPACK FOOTER //
// ./app/javascript/components/designer_calendars/components/TaskPopup.js